export function captureException(error: Error, extra: unknown = {}): void {
  console.error(error, extra);
}
